import { render, staticRenderFns } from "./objectGZAdd.vue?vue&type=template&id=a68fcce6&scoped=true"
import script from "./objectGZAdd.vue?vue&type=script&lang=js"
export * from "./objectGZAdd.vue?vue&type=script&lang=js"
import style0 from "./objectGZAdd.vue?vue&type=style&index=0&id=a68fcce6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68fcce6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a68fcce6')) {
      api.createRecord('a68fcce6', component.options)
    } else {
      api.reload('a68fcce6', component.options)
    }
    module.hot.accept("./objectGZAdd.vue?vue&type=template&id=a68fcce6&scoped=true", function () {
      api.rerender('a68fcce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/object/objectGZAdd.vue"
export default component.exports